/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - CSS
 */
import './styles/Button.css'

export const Button = (props: any) => {
    return (
        <button
            className={`btn${(props.type === 'submit') ? ' btn--submit' : ''} ${(props.half) ? ' btn--half' : ''} ${(props.className) ? props.className : ''}`}
            type={props.type}
            disabled={props.disabled}
            onClick={props.onClick}
        >
            {props.children}
        </button>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Button/Button.tsx